import { render, staticRenderFns } from "./fingerpostList.vue?vue&type=template&id=15cf6e41&scoped=true&"
import script from "./fingerpostList.vue?vue&type=script&lang=js&"
export * from "./fingerpostList.vue?vue&type=script&lang=js&"
import style0 from "./fingerpostList.vue?vue&type=style&index=0&id=15cf6e41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf6e41",
  null
  
)

export default component.exports